<div class="guest-tab-container">

	<div *ngIf="snapshot === null" class="spinner-wrap">
		<p-progressSpinner></p-progressSpinner>
	</div>

	<div *ngIf="snapshot !== null">
		<app-kpi-snapshot [kpis]="snapshot.kpis"></app-kpi-snapshot>

		<div class="coming-soon-section">
			<h3 class="section-title">Active Campaigns</h3>
			<div class="coming-soon-placeholder">Coming Soon</div>
		</div>

		<div class="coming-soon-section">
			<h3 class="section-title">Marketing Alerts</h3>
			<div class="coming-soon-placeholder">Coming Soon</div>
		</div>
	</div>

</div>
